"use client";

import type { ComponentProps } from "react";

import { useCheckoutContext } from "../../Checkout.hooks";
import CheckoutButton from "../../CheckoutContinueButton";
import { adyenStore } from "./Adyen.store";

type AdyenWidgetReloadButton = ComponentProps<"button">;

export default function AdyenWidgetReloadButton(
  props: AdyenWidgetReloadButton,
) {
  const { dictionary, adyenDropInRef } = useCheckoutContext();
  const reloadAdyenDropIn = adyenStore((state) => state.reloadAdyenDropIn);
  const adyenDropInError = adyenStore((state) => state.adyenDropInError);
  const setAdyenDropInError = adyenStore((state) => state.setAdyenDropInError);

  if (!adyenDropInError) {
    return null;
  }

  return (
    <CheckoutButton
      type="button"
      onClick={() => {
        reloadAdyenDropIn(adyenDropInRef);
        setAdyenDropInError(undefined);
      }}
      {...props}
    >
      {dictionary.tryAgain ?? "Try again"}
    </CheckoutButton>
  );
}
